import { render, staticRenderFns } from "./ObservatoriesChartDialog.vue?vue&type=template&id=52ac0950&scoped=true&"
import script from "./ObservatoriesChartDialog.vue?vue&type=script&lang=js&"
export * from "./ObservatoriesChartDialog.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoriesChartDialog.vue?vue&type=style&index=0&id=52ac0950&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac0950",
  null
  
)

export default component.exports